<template>
  <!-- Map View -->
  <div class="c-outages-container">
    <div v-if="outagePageView === 'map'" class="c-outages-container__mapview">
      <div class="c-outages-container__mapview-wrapper">
        <div class="c-outages-container__mapview-outages">
          <outage-search v-if="filterOption != 'lv'"></outage-search>
          <lv-outage-content v-if="lvOutagesEnabled"></lv-outage-content>
          <outages-results
            class="c-outages-container__mapview-results"
          ></outages-results>
        </div>
        <div class="c-outages-container__mapview-map">
          <outages-map></outages-map>
          <div class="c-outages-container__mapview-map-legend">
            <template v-if="filterOption === 'lv'">
              <div class="c-outages-container__mapview-map-legend-outage">
                <span
                  class="c-outages-container__mapview-map-legend-lv-icon c-outages-container__mapview-map-legend-lv-icon--all-restored"
                ></span>
                <h3 class="c-outages-container__mapview-map-legend-text">
                  All Restored
                </h3>
              </div>
              <div class="c-outages-container__mapview-map-legend-outage">
                <span
                  class="c-outages-container__mapview-map-legend-lv-icon c-outages-container__mapview-map-legend-lv-icon--in-progress"
                ></span>
                <h3 class="c-outages-container__mapview-map-legend-text">
                  In Progress
                </h3>
              </div>
              <div class="c-outages-container__mapview-map-legend-outage">
                <span
                  class="c-outages-container__mapview-map-legend-lv-icon c-outages-container__mapview-map-legend-lv-icon--not-started"
                ></span>
                <h3 class="c-outages-container__mapview-map-legend-text">
                  Not Attended
                </h3>
              </div>
              <div class="c-outages-container__mapview-map-legend-outage">
                <span
                  class="c-outages-container__mapview-map-legend-lv-icon c-outages-container__mapview-map-legend-lv-icon--no-lv-faults-reported"
                ></span>
                <h3 class="c-outages-container__mapview-map-legend-text">
                  No property faults reported
                </h3>
              </div>
            </template>
            <template v-else>
              <div class="c-outages-container__mapview-map-legend-outage">
                <img
                  class="c-outages-container__mapview-map-legend-icon"
                  src="_resources/app/client/assets/icons/outages-map/unplanned-outage-icon.svg"
                />
                <h3 class="c-outages-container__mapview-map-legend-text">
                  Unplanned outage
                </h3>
              </div>
              <div class="c-outages-container__mapview-map-legend-outage">
                <img
                  class="c-outages-container__mapview-map-legend-icon"
                  src="_resources/app/client/assets/icons/outages-map/planned-outage-icon.svg"
                />
                <h3 class="c-outages-container__mapview-map-legend-text">
                  Planned outage
                </h3>
              </div>
            </template>
          </div>
        </div>
        <outages-messages></outages-messages>
      </div>
    </div>
    <!-- List View -->
    <div v-else class="c-outages-container__listview">
      <outage-search v-if="filterOption != 'lv'"></outage-search>
      <lv-outage-content v-if="lvOutagesEnabled"></lv-outage-content>
      <div class="c-outages-container__listview-results-wrapper">
        <div class="c-outages-container__listview-results">
          <outages-results></outages-results>
        </div>
        <div class="c-outages-container__listview-sidebar">
          <outages-footer></outages-footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";

import OutageSearch from "./OutageSearch.vue";
import OutagesResults from "./OutagesResults.vue";
import OutagesMap from "./OutagesMap.vue";
import OutagesFooter from "./OutagesFooter.vue";
import OutagesMessages from "./OutagesMessages.vue";
import LvOutageContent from "./LvOutageContent.vue";

export default {
  created() {},
  components: {
    OutageSearch,
    OutagesResults,
    OutagesMap,
    OutagesFooter,
    OutagesMessages,
    LvOutageContent,
  },
  mounted() {},
  computed: {
    ...mapFields(["outagePageView", "filterOption", "lvOutagesEnabled"]),
    ...mapGetters(["getMarkerIcon"]),
  },
  methods: {},
};
</script>

<style lang="scss"></style>
